import _ from 'lodash';

export const FEATURE_FLAGS = {
  isMentorMatchEnabled: { label: 'MentorMatch', defaultValue: false },
  isCoachMatchEnabled: { label: 'CoachMatch', defaultValue: false },
  isConferenceMentorMatchEnabled: { label: 'Conference MentorMatch', defaultValue: false },
  isDiscernmentSurveyEnabled: { label: 'Discernment Survey', defaultValue: false },
  isHsfUniversityEnabled: { label: 'HSF University', defaultValue: false },
  isRealTimeChatEnabled: { label: 'Real Time Chat', defaultValue: false },
  isFinancialPortalEnabled: { label: 'Financial Portal', defaultValue: false },
  isFundAScholarEnabled: { label: 'Fund A Scholar', defaultValue: false },
  isEmailCommunicationEnabled: { label: 'Email Communication', defaultValue: true },
};

export const FEATURE_FLAG_FIELDS = _.map(FEATURE_FLAGS, ({ label }, key) => ({
  component: 'switchField',
  label,
  name: `featuresConfiguration.${key}`,
}));

export const FEATURE_FLAG_DEFAULTS = _.mapValues(FEATURE_FLAGS, ({ defaultValue }) => defaultValue);

export const featureFlagsSchema = (yup) => yup.object().shape(_.mapValues(FEATURE_FLAGS, () => yup.bool().required()));

export const withFeatureFlagDefaults = (tenant) => ({
  ...tenant,
  featuresConfiguration: { ...FEATURE_FLAG_DEFAULTS, ...tenant.featuresConfiguration },
});
